import type { HeaderLinkInternal } from '@scalar-org/entities/project'
import type { Router } from 'vue-router'

/** * Resolve the link (href) for an internal header item */
export function resolveHeaderLink(item: HeaderLinkInternal, router: Router) {
  return router.resolve({ name: item.uid }).href
}
